import { render } from "./CompanyLogoUpload.vue?vue&type=template&id=3bb2bd02&scoped=true"
import script from "./CompanyLogoUpload.vue?vue&type=script&lang=js"
export * from "./CompanyLogoUpload.vue?vue&type=script&lang=js"

import "./CompanyLogoUpload.vue?vue&type=style&index=0&id=3bb2bd02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb2bd02"]])

export default __exports__